export function waitAnimationFrame(frames = 1) {
    return new Promise((res) => {
        let count = 0

        var loop = () => {
            requestAnimationFrame(() => {
                count++
                if (count >= frames) {
                    res()
                } else {
                    loop()
                }
            })
        }

        loop()
    })
}
